import React from 'react';
import styled, { css } from 'styled-components';

const LabelElement = styled.label`
  color: #A0A0A0;
  font-size: 12px !important;
   
  position: absolute;
  transform: translate(10px, -8px);
  background: #fff;
  padding: 0 8px 0 6px;
  z-index: 99;
`;

const InputElement = styled.input`
  width: 328px;
  height: 22px;
  border-radius: 6px;
  padding: 14px 12px 11px 12px;
  box-sizing: content-box;
  line-height: 0px;
  font-size: 12px !important;

  &.bordered {
    border: 1.5px solid #A0A0A0;
  }

  &.filled {
    border: none;
    background: #F3F2F2;
  }

  ${(props) => props.disabled && css`
    cursor: not-allowed;
    background-color: #b5b5b5;
  `}

  ${(props) => props.full && css`
    width: 100%;
  `}

`;

const Input = ({
  label,
  ariaLabel,
  type,
  variant,
  placeholder,
  inputRef,
  ...props
}) => (
  <>
    {
      label ? (
        <LabelElement htmlFor="input">
          {label}
        </LabelElement>
      ) : null
    }
    <InputElement
      type={type}
      id="input"
      onKeyDown={(e) => e.stopPropagation()}
      aria-label={ariaLabel || 'please fill the input box'}
      className={variant || 'bordered'}
      placeholder={placeholder || ''}
      ref={inputRef}
      {...props}
    />
  </>
);

export default Input;
